import { ClassCard, TabBar, TabItem } from '@wot/components';
import { ITrialClass } from '@wot/typings';
import { useEffect, useState } from 'react';
import { MdOutlineDateRange, MdOutlineList } from 'react-icons/md';
import { useParams } from 'react-router-dom';
import { DEFAULT_PROFILE_PIC } from '../../../../assets/icons';
import Calender from '../../../../components/Calender/Calender';
import CalenderProvider from '../../../../components/Calender/CalenderContext';
import { useTab } from '../../../../hooks/useTab';
import xhr from '../../../../utils/fetch';

export default function StudentCalendar() {
  const { activeTab, onTabChange } = useTab('all');
  const [classes, setClasses] = useState<ITrialClass[]>([]);
  const [view, setView] = useState<'calender' | 'list'>('list');
  const { student_id } = useParams();

  useEffect(() => {
    xhr({
      url: `/u/${student_id}/sessions`,
      method: 'GET'
    }).then((res) => {
      setClasses(res.data);
    });
  }, []);

  return (
    <div className="w-full h-full min-h-screen bg-[#F5F6F9]">
      <div className="w-full h-full mx-auto p-4">
        <div className="w-full h-full flex flex-col bg-white rounded-md">
          <div className="w-full border-b border-black">
            <div className="px-4">
              <TabBar
                value={activeTab}
                indicatorColor="bg-secondary"
                onChange={onTabChange}
                textColor="text-neutralGray1"
              >
                <TabItem label="All Classes" value="all" fontSize={15} />
                <TabItem label="Upcoming" value="upcoming" />
                <TabItem label="Completed" value="completed" />
                <TabItem label="Cancelled" value="cancelled" />
              </TabBar>
            </div>
          </div>

          <div className="w-full px-7 py-4 bg-neutralGray4 flex items-center gap-5">
            <p className="text-base font-semibold">Filters</p>

            <div className="flex items-center rounded-md border ml-auto overflow-hidden">
              <div
                onClick={() => setView('calender')}
                className={`w-10 h-10 flex items-center justify-center ${
                  view === 'calender' ? 'bg-neutralBlue2' : 'bg-white'
                }`}
              >
                <MdOutlineDateRange className="w-4 h-4 cursor-pointer" />
              </div>
              <div
                onClick={() => setView('list')}
                className={`w-10 h-10 flex items-center justify-center ${
                  view === 'list' ? 'bg-neutralBlue2' : 'bg-white'
                }`}
              >
                <MdOutlineList className="w-4 h-4 cursor-pointer" />
              </div>
            </div>
          </div>

          {view === 'calender' ? (
            <div className="flex p-7">
              <CalenderProvider>
                <Calender
                  bookedSlots={classes.map((session) => ({
                    status: session.status,
                    user: session.tutor,
                    type: session.type,
                    category: session.category,
                    slot: session.scheduledTime
                  }))}
                />
              </CalenderProvider>
            </div>
          ) : (
            <div className="flex flex-col gap-4 my-10 px-4">
              {activeTab === 'all' ? (
                classes.length === 0 ? (
                  <div className="w-full flex flex-col items-center justify-center gap-7 py-10">
                    <h1 className="text-2xl font-semibold">{`No classes yet!`}</h1>
                  </div>
                ) : (
                  classes.map((session) => <ClassItem key={session._id} session={session} />)
                )
              ) : classes.filter((plan) => plan.status === activeTab).length === 0 ? (
                <div className="w-full flex flex-col items-center justify-center gap-7 py-10">
                  <h1 className="text-2xl font-semibold">{`No ${activeTab} classes yet!`}</h1>
                </div>
              ) : (
                classes
                  .filter((c) => c.status === activeTab)
                  .map((session) => <ClassItem key={session._id} session={session} />)
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export function ClassItem({ session }: { session: ITrialClass }) {
  return (
    <>
      <ClassCard
        _id={session._id}
        type={session.type}
        category={session.category}
        endTime={new Date(session.scheduledTime.end)}
        startTime={new Date(session.scheduledTime.start)}
        name={session.tutor?.name || ''}
        profilePic={session.tutor?.profilePic || DEFAULT_PROFILE_PIC}
        status={session.status}
        showJoinBtn={false}
        showCancelBtn={false}
        showRescheduleBtn={false}
      />
    </>
  );
}
